/**
 * 最近見た商品
 */
(async function () {
  // 最近見た商品表示エリア
  const recently = document.querySelector('#recently');

  if (!recently) return;

  /**
   * Liquidからdata属性で渡された設定値
   */
  const STORAGE_KEY = recently.dataset.storageKey;
  const dispLimit = Number(recently.dataset.dispLimit) || 4;
  const adjustDispLimit = dispLimit + 1;

  const currentHandle = recently.dataset.productHandle;
  const productUrl = recently.dataset.productUrl;

  const loadingText = recently.dataset.loadingText || '読み込み中...';

  const emptyText = recently.dataset.emptyText || '最近見た商品はありません';

  /**
   * 必須設定がない場合は終了
   */
  if (!STORAGE_KEY || !productUrl) {
    return;
  }

  /**
   * ローカルストレージから閲覧履歴を取得
   */
  let remindProducts = [];

  try {
    remindProducts = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

    // 配列でない場合は初期化
    if (!Array.isArray(remindProducts)) {
      remindProducts = [];
    }
  } catch (error) {
    console.error('ローカルストレージの読み込みに失敗しました:', error);

    remindProducts = [];
  }

  /**
   * 空要素など、不正なデータを削除
   */
  remindProducts = remindProducts.filter((item) => item?.handle);

  /**
   * 商品ページの場合、
   * 現在表示している商品を履歴から除外
   *
   * このあと履歴の先頭へ追加する
   */
  if (currentHandle) {
    remindProducts = remindProducts.filter((item) => item.handle !== currentHandle);
  }

  /**
   * 最近見た商品を表示
   */
  if (remindProducts.length > 0) {
    // 履歴が存在するときだけローディングを表示
    recently.innerHTML = `
      <div class="recently-loading">
        <span class="recently-loading__spinner"></span>
        <span>${loadingText}</span>
      </div>
    `;

    /*
     * 商品一覧を表示し、
     * 整理後の履歴を受け取る
     */
    remindProducts = await dispRecentList(remindProducts, dispLimit);
  } else {
    // 履歴が0件ならローディングを表示しない
    displayEmpty();
  }

  /**
   * 現在表示している商品を
   * 履歴の先頭へ追加
   */
  if (currentHandle) {
    remindProducts.unshift({
      handle: currentHandle,
    });
  }

  /**
   * 保存件数を制限
   *
   * 表示件数 + 現在の商品1件
   */
  remindProducts = remindProducts.slice(0, adjustDispLimit);

  /**
   * ローカルストレージに保存
   */
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(remindProducts));
  } catch (error) {
    console.error('ローカルストレージへの保存に失敗しました:', error);
  }

  /**
   * 商品データ取得
   */
  async function getProductData(handle) {
    const url = productUrl + encodeURIComponent(handle) + '?view=ajax-recently-viewed';

    try {
      const response = await fetch(url, {
        method: 'GET',
      });

      /**
       * 商品が存在しない
       *
       * この場合は履歴から削除してよい
       */
      if (response.status === 404) {
        return {
          status: 'not_found',
          product: null,
        };
      }

      /**
       * 404以外のHTTPエラー
       *
       * 一時的なサーバーエラー等の可能性があるので
       * 履歴からは削除しない
       */
      if (!response.ok) {
        console.warn('商品データの取得に失敗しました:', handle, response.status);

        return {
          status: 'error',
          product: null,
        };
      }

      const data = await response.text();

      const parser = new DOMParser();

      const doc = parser.parseFromString(data, 'text/html');

      const product = doc.querySelector('.card-wrapper');

      /**
       * 正常レスポンスだが
       * 商品カードが取得できなかった場合
       *
       * テンプレート側の一時的な問題等も考えられるので
       * 履歴は残す
       */
      if (!product) {
        console.warn('商品カードが見つかりませんでした:', handle);

        return {
          status: 'error',
          product: null,
        };
      }

      /**
       * 正常取得
       */
      return {
        status: 'success',
        product: product,
      };
    } catch (error) {
      /**
       * 通信エラー
       *
       * オフラインや一時的な通信障害などが
       * 考えられるので履歴は残す
       */
      console.error('商品データの通信に失敗しました:', handle, error);

      return {
        status: 'error',
        product: null,
      };
    }
  }

  /**
   * 最近見た商品リスト表示
   */
  async function dispRecentList(datas, dispLimit) {
    /**
     * 商品データを並列取得
     */
    const results = await Promise.all(
      datas.map(async (item) => {
        const result = await getProductData(item.handle);

        return {
          handle: item.handle,
          status: result.status,
          product: result.product,
        };
      }),
    );

    /**
     * 正常に取得できた商品
     */
    const validResults = results.filter((item) => item.status === 'success');

    /**
     * 表示対象の商品
     */
    const displayProducts = validResults.slice(0, dispLimit);

    /**
     * 表示
     */
    if (displayProducts.length === 0) {
      displayEmpty();
    } else {
      let recentList = `
        <ul class="grid product-grid contains-card contains-card--product">
      `;

      displayProducts.forEach((item, index) => {
        recentList += `
            <li
              class="grid__item scroll-trigger animate--slide-in"
              data-cascade
              style="--animation-order: ${index};"
            >
              ${item.product.outerHTML}
            </li>
          `;
      });

      recentList += '</ul>';

      recently.innerHTML = recentList;
    }

    /**
     * localStorageに残す履歴
     *
     * not_found（404）の商品だけ削除
     *
     * success → 残す
     * error   → 残す
     * not_found → 削除
     */
    return results
      .filter((item) => item.status !== 'not_found')
      .map((item) => ({
        handle: item.handle,
      }));
  }

  /**
   * 最近見た商品がない場合
   */
  function displayEmpty() {
    recently.innerHTML = `
      <div class="noRecentlyItem">
        ${emptyText}
      </div>
    `;
  }
})();
